// extracted by mini-css-extract-plugin
export default {"frame":"PdfPreview_frame__jAnbG","pdf_page":"PdfPreview_pdf_page__3E1XE"};